var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dns-provider-webhuset"},_vm._l((_vm.items),function(item,index){return _c('Item',{attrs:{"value":item,"order":index}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }